import React from 'react';
import "./CreatAccount.scss";

export default function CreatAccount() {
  return (
    <div className='creat-account'>
      <div className='container w-75 mx-auto'>
        <h4 className='text-center mb-5'>Create a Work Team Account</h4>

        <form>
          <div className='d-flex align-items-center justify-content-between mb-4'>
            <input type="text" className="input" placeholder="First Name" />
            <input type="text" className="input" placeholder="Last Name" />
          </div>

          <div className='d-flex align-items-center justify-content-between mb-4'>
            <input type="text" className="input" placeholder="Email" />
            <input type="text" className="input" placeholder="Phone" />
          </div>

          <div className='mb-4'>
            <input type="text" className="input" placeholder="Team Name" />
          </div>
              <div className='mb-4'>
            <input type="text" className="input" placeholder="Team Name" />
          </div>
              <div className='mb-4'>
            <input type="text" className="input" placeholder="Team Name" />
          </div>
        </form>
      </div>

         <div className="settings-info-actions container">
          <button type="button" className="cancel">CANCEL</button>
          <button type="submit" className="confirm">CONFIRM</button>
        </div>
    </div>
  );
}
